import { format, isValid } from "date-fns";

export const getSafeDate = (
  date: any,
  dateFormat = "dd/MM/yyyy",
): string | null =>
  isValid(new Date(date)) ? format(new Date(date), dateFormat) : null;
